import { ProjectResource } from '../project/ProjectTypes.ts';
import { Technologies } from '../project/components/projectTechnologies/ProjectTechnologiesTypes.ts';
import { ProjectUrlsType } from '../project/components/projectUrls/ProjectUrlsTypes.ts';

/**
 * Technologies used in the Lingo project.
 */
const TECHNOLOGIES: Technologies = [
    'Python'
] as const;

/**
 * URLs for the Lingo project.
 */
const PROJECT_URLS: ProjectUrlsType = {
    github: 'https://github.com/99061142/Lingo-Python'
} as const;

const COMPLETION_YEAR: number = 2025;

export const lingoResource: ProjectResource = {
    nl: {
        title: 'Lingo',
        description: 'Voor mijn eind project voor mijn eerste leerjaar in Software Developer heb ik gekozen om Lingo te maken. In Lingo proberen 2 teams omstebeurt een woord van 5 letters te raden, en tegelijkertijd een gevulde rij te krijgen op het Bingo bord.',
        technologies: {
            title: 'Gebruikte technologieën',
            usedTechnologies: TECHNOLOGIES
        },
        features: {
            title: 'Kenmerken',
            items: [
                'Visualisatie van het Wordle bord in de terminal',
                'Visualisatie van het Bingo bord in de terminal',
                'Mogelijkheid om Lingo opnieuw te spelen na het einde van het spel'
            ]
        },
        urls: PROJECT_URLS,
        status: {
            status: 'Dit project is voltooid in',
            completionMonth: 'november',
            completionYear: COMPLETION_YEAR,
            isFinished: true
        }
    },
    en: {
        title: 'Lingo',
        description: "For my final project for my first college year of Software Developer, I chose to create Lingo. In this game, 2 teams take turns trying to guess a 5-letter word, while also trying to get a row on the Bingo board.",
        technologies: {
            title: 'Used technologies',
            usedTechnologies: TECHNOLOGIES
        },
        features: {
            title: 'Features',
            items: [
                'Visualization of the Wordle board in the terminal',
                'Visualization of the Bingo board in the terminal',
                'Ability to replay Lingo after the game ends'
            ]
        },
        urls: PROJECT_URLS,
        status: {
            status: 'This project was completed in',
            completionMonth: 'November',
            completionYear: COMPLETION_YEAR,
            isFinished: true
        }
    }
} as const;